module.exports = __webpack_public_path__ + "img/home.04de807f.gif";